// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"4c02e217","43":"2d20a908","675":"5e8d4b0d","696":"19d39984","732":"c251aadf","920":"d2acc5c6"}[chunkId] + ".chunk.js";
};